import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import orderConsignmentVector from 'assets/images/order-consignment-vector.svg'
import CN from 'classnames'

export interface ManageOrdersLandingProps {
  [x: string]: any
}

export const MANAGE_ORDERS_URL = '/customer-order/manage-orders'
export const CHANGE_ORDER_STATUS_URL = `${MANAGE_ORDERS_URL}/change-order-status`
export const SSCC_XML_URL = `${MANAGE_ORDERS_URL}/sscc-xml-validation`

const buttonClass =
  'w-[350px] h-16 px-6 rounded-lg text-lg font-extrabold text-white flex items-center justify-between gap-3 text-left shadow-sm'

interface LandingOption {
  key: string
  label: string
  colorClass: string
  url?: string
  disabledReason?: string
}

/** Options shown on the Manage Orders landing page, top to bottom. */
const landingOptions: LandingOption[] = [
  {
    key: 'bulk',
    label: 'Change Order Status – Bulk',
    colorClass: 'bg-[#0B7A57] hover:brightness-110',
    url: CHANGE_ORDER_STATUS_URL,
  },
  {
    key: 'sscc',
    label: 'SSCC XML Validation',
    colorClass: 'bg-[#B87B3A] hover:brightness-110',
    url: SSCC_XML_URL,
  },
  {
    key: 'dc',
    label: 'Dispatch Confirmation Validation',
    colorClass: 'bg-[#64748B]',
    disabledReason: 'Coming soon',
  },
]

export const ManageOrdersLanding: FC<ManageOrdersLandingProps> = ({
  className,
}: ManageOrdersLandingProps) => {
  const navigate = useNavigate()

  return (
    <div
      className={CN(
        'relative flex items-center justify-start bg-N-50 h-full w-full pt-4 px-8 pb-4',
        className,
      )}>
      <div
        className='bg-white p-8 rounded-lg shadow-md flex flex-col justify-center absolute inset-4 overflow-auto'
        style={{
          backgroundImage: `url(${orderConsignmentVector})`,
          backgroundSize: '1050px',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'calc(100% - 30px) calc(100% - 70px)',
        }}>
        <div className='flex flex-col gap-[18px]'>
          {landingOptions.map((option) => {
            const isDisabled = !option.url
            return (
              <button
                key={option.key}
                type='button'
                title={option.disabledReason}
                disabled={isDisabled}
                aria-disabled={isDisabled}
                onClick={() => option.url && navigate(option.url)}
                className={CN(buttonClass, option.colorClass, {
                  'opacity-60 cursor-not-allowed': isDisabled,
                })}>
                <span>{option.label}</span>
                {isDisabled ? (
                  <span className='text-xs font-semibold uppercase tracking-wide'>
                    {option.disabledReason}
                  </span>
                ) : (
                  <i className='ri-arrow-right-s-line text-2xl' />
                )}
              </button>
            )
          })}
        </div>
      </div>
    </div>
  )
}

ManageOrdersLanding.defaultProps = {}

export default ManageOrdersLanding
